//FIXME: any to proper type
export function unpackSnapshot({ snapshot }: { snapshot: any }) {
  return {
    ...snapshot.data(),
    id: snapshot.id,
  };
}
